import { Directive, ElementRef, Input } from '@angular/core';
import {FileService} from "../../routes/jy-content/attachment/service/file.service";
@Directive({
  selector: '[attachment-src]',
})
export class AttachmentSrcDirective {

  constructor(private elementRef: ElementRef,
              private fileService: FileService,
  ) {
  }

  @Input('attachment-src')
  set attachmentSrc(key: string) {
    if (key) {
      this.elementRef.nativeElement.src = this.fileService.getDownloadFileFullUrl(key);
    }
  }
}
